export default __webpack_public_path__ + "images/2_services_person_1.jpg";